export const mockMenuData = {
  soir: {
    title: "Carte du Soir",
    subtitle: "Carte Hivernale",
    menuThermes: {
      title: "Menu Thermes",
      price: "49€",
      note: "Servi le soir et le week-end",
      choices: {
        entrees: [
          "Terrine de foie gras de canard mi-cuit, confit d'oignons, pain d'épices toasté",
          "Noix de Saint-Jacques juste saisies, étuvée de poireaux, sauce porto"
        ],
        plats: [
          "Dos de cabillaud skrei snacké, pommes de terre écrasées, huile d'herbes",
          "Cuisses de grenouilles en persillade, pommes grenailles, légumes du moment, sauce au riesling"
        ],
        fromageOuDessert: [
          "Chariot de fromages de notre région, confiture de figue",
          "Dessert au choix à la carte"
        ]
      }
    },
    sections: {
      entrees: {
        title: "Entrées",
        dishes: [
          {
            name: "Suprêmes de cailles rôtis, servis tièdes",
            description: "Saladine de lentilles aux aromates, mâche, pickles d'oignons rouges, jus corsé au balsamique",
            price: "15€"
          },
          {
            name: "Velouté de potimarron, façon cappuccino",
            description: "Crème légère, noisettes torréfiées, éclats de châtaignes",
            price: "14€"
          },
          {
            name: "Noix de Saint-Jacques juste saisies",
            description: "Étuvée de poireaux, sauce porto",
            price: "17€"
          },
          {
            name: "Terrine de foie gras de canard mi-cuit",
            description: "Confit d'oignons, pain d'épices toasté",
            price: "20€"
          }
        ]
      },
      plats: {
        title: "Plats",
        dishes: [
          {
            name: "Risotto arborio crémeux au mascarpone",
            description: "Champignons de Paris, coulis de cresson, dentelle de parmesan",
            price: "19€"
          },
          {
            name: "Paleron de bœuf confit toute la nuit",
            description: "Polenta crémeuse, duo de carottes braisées, jus réduit",
            price: "24€"
          },
          {
            name: "Dos de cabillaud skrei snacké",
            description: "Pommes de terre écrasées à l'huile d'olive et ciboulette, beurre nantais, huile d'herbes",
            price: "26€"
          },
          {
            name: "Filets de perches meunière",
            description: "Sauce tartare, saladine du moment, pommes frites",
            price: "28€"
          },
          {
            name: "Cuisses de grenouilles en persillade",
            description: "Pommes grenailles, légumes du moment, sauce au riesling",
            price: "28€"
          },
          {
            name: "Tournedos de bœuf au sautoir",
            description: "Pressé de pommes de terre au comté, duo de carottes braisées, sauce bordelaise",
            price: "32€"
          }
        ]
      },
      desserts: {
        title: "Les Gourmandises",
        dishes: [
          {
            name: "Poire pochée",
            description: "Sauce chocolat, crémeux vanille, spéculos",
            price: "9€"
          },
          {
            name: "Vacherin glacé \"Franco-Suisse\"",
            description: "Myrtille, double crème",
            price: "11€"
          },
          {
            name: "Tiramisu à la crème de marrons",
            description: "",
            price: "9€"
          },
          {
            name: "Brioche perdue de mon enfance",
            description: "Chantilly, caramel au beurre salé, glace à la noix de macadamia",
            price: "9€"
          },
          {
            name: "Plateau de fromages affinés de notre région",
            description: "Confiture de figue",
            price: "12€"
          }
        ]
      }
    }
  },
  midi: {
    title: "Menu Déjeuner",
    subtitle: "Du mardi au vendredi midi",
    intro: "Deux menus sont proposés en semaine.",
    weeklyMenu: {
      title: "Menu de la semaine",
      price: "25€",
      dates: "Du mardi 10 au vendredi 13 mars",
      dishes: {
        entree: "Rémoulade de carottes, céleri-rave et pomme granny, graines de moutarde et herbes fraîches, magret fumé",
        plat: "Poulet sauté façon chasseur, mousseline de panais, champignons de Paris",
        dessert: "Baba bouchon au rhum, chantilly vanille"
      },
      note: "Ce menu change chaque semaine selon les produits de saison."
    },
    menuSource: {
      title: "Menu Source",
      price: "35€",
      subtitle: "Uniquement le midi en semaine",
      entrees: [
        "Les suprêmes de cailles rôties, servis tièdes, autour d'une saladine de lentilles aux aromates, mâche, pickles d'oignons rouges, jus corsé au balsamique",
        "Velouté de potimarron, comme un cappuccino à la noisette, éclats de châtaigne"
      ],
      plats: [
        "Risotto arborio moelleux à la mascarpone et champignons de Paris, coulis de cresson de fontaine, dentelle de parmesan",
        "Noix de Saint-Jacques juste saisies, étuvée de poireaux, sauce porto",
        "Paleron de bœuf confit lentement toute la nuit, polenta crémeuse, duo de carottes braisées, jus de cuisson réduit"
      ],
      desserts: [
        "Brioche perdue de mon enfance, chantilly caramel au beurre salé, glace à la noix de macadamia",
        "Tiramisu à la crème de marrons",
        "La douceur de la semaine"
      ],
      note: "Paleron de bœuf : origine Allemagne"
    },
    sections: {
      entrees: { title: "Entrées", dishes: [] },
      plats: { title: "Plats", dishes: [] },
      desserts: { title: "Les Gourmandises", dishes: [] }
    }
  }
};

export const mockReservations = [];

export const contactInfo = {
  address: "50 Rue de Lausanne, 01220 Divonne-les-Bains",
  phone: "+33 4 50 28 88 57",
  email: "larotonde.divonne@gmail.com",
  hours: {
    title: "Horaires d'ouverture",
    weekdays: {
      days: "Du mardi au samedi",
      lunch: "Déjeuner : 11h45 – 14h00",
      dinner: "Dîner : 19h30 – 22h00"
    },
    sunday: {
      day: "Dimanche",
      lunch: "Déjeuner : 11h45 – 15h00"
    },
    closed: "Fermé le dimanche soir et le lundi"
  }
};

export const historyData = [
  {
    year: "1891",
    title: "La naissance de La Rotonde",
    description: "L'histoire de La Rotonde débute en 1891, à une époque où Divonne-les-Bains s'impose comme une station thermale et hôtelière de renom. Construite attenante au Grand Hôtel — aujourd'hui le Casino — La Rotonde abritait alors un café-billard, lieu de détente et de rencontres pour les curistes venus profiter des bienfaits de la station. On s'y retrouvait après les soins, dans une atmosphère élégante et animée, reflet de la vie mondaine de la Belle Époque."
  },
  {
    year: "1932",
    title: "Une reconstruction à l'identique",
    description: "En 1932, le bâtiment est démonté puis reconstruit à l'identique pour devenir le salon et la salle à manger de l'hôtel Bon Accueil. Pendant plusieurs décennies, il accompagne l'essor de Divonne et accueille les visiteurs qui contribuent à la renommée de la station."
  },
  {
    year: "Aujourd'hui",
    title: "Une nouvelle page",
    description: "Préservée et restaurée avec soin, La Rotonde conserve l'élégance de son architecture d'origine. Aujourd'hui, elle ouvre un nouveau chapitre de son histoire, fidèle à l'esprit d'accueil qui l'anime depuis plus d'un siècle."
  }
];
